export default "__VITE_ASSET__00151112__"